//TODO: Move this to jUtils.js somehow.
document.querySelectorAll("#mobile-menu a").forEach((anchor) => {
  // Check if the href attribute value starts with '#'
  if (anchor.getAttribute("href").startsWith("#")) {
    anchor.addEventListener("click", (event) => {
      // Prevent the default anchor link behavior
      event.preventDefault();

      // Debugging: log the href attribute value.
      console.debug(
        "Anchor link to the same page clicked:",
        anchor.getAttribute("href"),
      );

      document.querySelector("#mobile-navbar").classList.remove("toggle");
      document.querySelector("#mobile-menu").classList.remove("toggle");
      document.querySelector("#mobile-menu-toggle").classList.remove("toggle");

      // Set the hash part of the URL to the href attribute value.
      window.location.hash = anchor.getAttribute("href");
    });
  }
});
